import React, { useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableRow from "@material-ui/core/TableRow";
import { getEarnedLeaves, getAdvanceAvailedLeaves } from "@utils/utils";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

export default function LeaveModule({ payroll }) {
  const [earnedLeaves] = useState(() => {
    return payroll.contract === "Permanent" && payroll.employee.yearly_quota > 0
      ? getEarnedLeaves(
          payroll.contract_started_date,
          payroll.used_leaves,
          payroll.salary_date,
          payroll.contract_status,
        )
      : 0;
  });
  return (
    <TableContainer>
      <Table style={{ padding: "0 0 10 1" }}>
        <TableBody>
          <StyledTableRow>
            <StyledTableCell>
              <b>Assigned Quota:</b>
            </StyledTableCell>
            <StyledTableCell>
            {payroll.contract === "Permanent"
                ? (payroll.employee.yearly_quota + payroll?.employee?.additional_yearly_quota) || 0
                : 0}
            </StyledTableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell>
              <b>Used Leaves:</b>
            </StyledTableCell>
            <StyledTableCell>{payroll.used_leaves}</StyledTableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell>
              <b>Earned Leaves:</b>
            </StyledTableCell>
            <StyledTableCell>
              {earnedLeaves > 0 ? earnedLeaves : 0}
            </StyledTableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell>
              <b>Advance Availed Leaves:</b>
            </StyledTableCell>
            <StyledTableCell>
              {getAdvanceAvailedLeaves(
                payroll.used_leaves,
                payroll.salary_date,
                payroll.contract_started_date,
                payroll.contract_status,
              ) > 0
                ? getAdvanceAvailedLeaves(
                    payroll.used_leaves,
                    payroll.salary_date,
                    payroll.contract_started_date,
                    payroll.contract_status,
                  )
                : 0}
            </StyledTableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell>
              <b>Current Month Leaves (Approved):</b>
            </StyledTableCell>
            <StyledTableCell>{payroll.availed_leaves}</StyledTableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell>
              <b>Current Month Leaves (Rejected):</b>
            </StyledTableCell>
            <StyledTableCell>{payroll.availed_rejected_leaves}</StyledTableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell>
              <b>Total Availed Leaves:</b>
            </StyledTableCell>
            <StyledTableCell>
              {payroll?.used_leaves}
            </StyledTableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell>
              <b>
                {payroll.remaining_leaves < 0
                  ? "Exceeding:"
                  : "Leaves Balance:"}
              </b>
            </StyledTableCell>
            <StyledTableCell>
              {Math.abs(payroll.remaining_leaves)}
            </StyledTableCell>
          </StyledTableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}
